import React, {useEffect} from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ScrollToTop from './helper/ScrollToTop';
import { GlobalStyle } from "./components/common/styles/global.js";
import HomeOne from './HomeOne';
import BuildingFacilityDetails from './pages/buildingfacility/BuildingFacilityDetails';
import ConciergeService from './pages/concierge/ConciergeService';
import CleaningService from './pages/cleaning/CleaningService';
import Services from './pages/service/Services';
import Contact from './pages/contact/Contact';
import PageNotFound from './pages/404/PageNotFound';
import Product from './pages/shop/Products';
import GardeningLandscaping from './pages/gardening/GardeningLandscaping';
import ProjectAndDeveloperService from './pages/developer/ProjectAndDeveloperService';
import CommunityPortal from './pages/community/CommunityPortal';
import Investment from './pages/investment/Investment';
import ClientsTestimonial from './pages/clientsTestimonial/ClientsTestimonial';
import { Provider } from 'react-redux';
import store from './redux/store';
import FullPageLoader from './helper/FullPageLoader';
import ReactGA from "react-ga";

const TRACKING_ID = "G-BXMDNTQ5YY"; // OUR_TRACKING_ID

ReactGA.initialize(TRACKING_ID);

function App() {    
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search);
      }, []);
    
    return (
        <Provider store={store}>
            <Router>
                <GlobalStyle />
                <ScrollToTop />
                <FullPageLoader />

                <Switch>
                    <Route exact path={`${process.env.PUBLIC_URL + "/"}`} component={HomeOne} />
                    <Route path={`${process.env.PUBLIC_URL + "/building-and-facility-management-services"}`} component={BuildingFacilityDetails} />
                    <Route path={`${process.env.PUBLIC_URL + "/concierge-services"}`} component={ConciergeService} />
                    <Route path={`${process.env.PUBLIC_URL + "/cleaning-services"}`} component={CleaningService} />
                    <Route path={`${process.env.PUBLIC_URL + "/gardening-and-landscaping-services"}`} component={GardeningLandscaping} />
                    <Route path={`${process.env.PUBLIC_URL + "/project-and-developer-services"}`} component={ProjectAndDeveloperService} />
                    <Route path={`${process.env.PUBLIC_URL + "/community-web-portal"}`} component={CommunityPortal} />
                    <Route path={`${process.env.PUBLIC_URL + "/clients-testimonial"}`} component={ClientsTestimonial} />
                    <Route path={`${process.env.PUBLIC_URL + "/investment"}`} component={Investment} />
                    <Route path={`${process.env.PUBLIC_URL + "/services"}`} component={Services} />
                    <Route path={`${process.env.PUBLIC_URL + "/contact"}`} component={Contact} />
                    <Route path={`${process.env.PUBLIC_URL + "/404"}`} component={PageNotFound} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-experience"}`} component={Product} />
                </Switch>
            </Router>
        </Provider>
    )
}

export default App;